const colorCodes  = [
  '#FF4136', // Red
  '#0074D9', // Blue
  '#2ECC40', // Green
  '#FFDC00', // Yellow
  '#B10DC9', // Purple
  '#FF851B', // Orange
  '#7FDBFF', // Cyan
  '#FF00FF', // Magenta
  '#39CCCC', // Teal

  '#FFDC80', // Peach
  '#CC8899', // Light Maroon
  '#3D9970', // Olive
  '#F012BE', // Fuchsia
  '#AAAAAA', // Gray
  '#FF6F61', // Coral
  '#FFD700', // Gold
  '#3E3A3A', // Dark Gray
  '#9966CC', // Amethyst
  '#7FFFD4', // Aquamarine

];
  

  module.exports={colorCodes}